import React from 'react';
import Header from './Header';
import Footer from './Footer';

const TermsConditions = () => {
    return (
        <>
            <Header isAlwaysScrolled={true} />
            <main className="pt-24 pb-20 bg-gray-50 dark:bg-black min-h-screen transition-colors duration-300">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl p-8 md:p-12 dark:border dark:border-gray-800 transition-colors duration-300">
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-8" style={{ fontFamily: "'Poppins', sans-serif" }}>
                            Terms & <span className="text-red-600">Conditions</span>
                        </h1>

                        <div className="prose prose-lg max-w-none text-gray-600 dark:text-gray-300 space-y-6" style={{ fontFamily: "'Poppins', sans-serif" }}>
                            <p>Last updated: {new Date().toLocaleDateString()}</p>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">1. Agreement to Terms</h3>
                            <p>
                                These Terms and Conditions constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you") and PizzaToons Foods & Beverages Private Limited ("Company", "we", "us", "our"), concerning your access to and use of the www.pizzatoons.in website as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the "Site").
                            </p>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">2. Intellectual Property Rights</h3>
                            <p>
                                Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the "Content") and the trademarks, service marks, and logos contained therein (the "Marks") are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws.
                            </p>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">3. User Representations</h3>
                            <p>
                                By using the Site, you represent and warrant that: (1) all registration information you submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of such information and promptly update such registration information as necessary; (3) you have the legal capacity and you agree to comply with these Terms of Use; (4) you are not a minor in the jurisdiction in which you reside.
                            </p>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">4. Products and Services</h3>
                            <p>
                                All products and services listed on the Site are subject to availability. We reserve the right to discontinue any product at any time for any reason. Prices for all products are subject to change.
                            </p>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">5. Limitation of Liability</h3>
                            <p>
                                In no event will we or our directors, employees, or agents be liable to you or any third party for any direct, indirect, consequential, exemplary, incidental, special, or punitive damages, including lost profit, lost revenue, loss of data, or other damages arising from your use of the site, even if we have been advised of the possibility of such damages.
                            </p>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">6. Governing Law</h3>
                            <p>
                                These Terms shall be governed by and defined following the laws of India. PizzaToons Foods & Beverages Private Limited and yourself irrevocably consent that the courts of Pune, Maharashtra shall have exclusive jurisdiction to resolve any dispute which may arise in connection with these terms.
                            </p>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">7. Contact Us</h3>
                            <p>
                                In order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:
                            </p>
                            <p className="mt-2">
                                <strong>PizzaToons Foods & Beverages Private Limited</strong><br />
                                Email: info@pizzatoons.in<br />
                                Phone: 07875550787
                            </p>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default TermsConditions;
